export const GET_STEP = 'GET_STEP';
export const GET_STEP_SUCCESS = 'GET_STEP_SUCCESS';
